import CreateRole from './Add';

export default CreateRole;
